var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFadScissors = function SvgFadScissors(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m109.46 97 44.708 44.47c1.96 1.95 5.792 3.387 8.545 3.21l6.667-.425c2.204-.14 4.856 1.319 5.918 3.25l33.82 61.458h-9.974l-100.55-101.06L109.46 97z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108.46 158.963 44.708-44.47c1.96-1.95 5.792-3.387 8.545-3.211l6.667.426c2.204.14 4.856-1.319 5.918-3.25L208.118 47h-9.974L97.594 148.06l10.866 10.903z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 81.575,
    cy: 81.575,
    r: 33.575
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 81.575,
    cy: 176.425,
    r: 33.575
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFF",
    cx: 81.601,
    cy: 177.377,
    rx: 17.601,
    ry: 17.623
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFF",
    cx: 81.601,
    cy: 82.377,
    rx: 17.601,
    ry: 17.623
  }))));
};
export { SvgFadScissors as ReactComponent };
export default __webpack_public_path__ + "static/media/fad-scissors.7b2496a8.svg";